import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "crm-board-edit-panel" }
const _hoisted_2 = { class: "crm-board-edit-title" }
const _hoisted_3 = { class: "crm-board-color-select" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "crm-board-edit-color"
}
const _hoisted_8 = { class: "crm-board-color-select" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "crm-board-edit-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createTextVNode("Columns", -1)),
      _createElementVNode("span", null, [
        _cache[10] || (_cache[10] = _createTextVNode("Drag to reorder", -1)),
        (_ctx.hint)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" · " + _toDisplayString(_ctx.hint), 1)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("form", {
      class: "crm-board-edit-add",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.addCol()), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Column name",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addColName) = $event))
      }, null, 512), [
        [_vModelText, _ctx.addColName]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addColColor) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.colorPalette, (color, i) => {
            return (_openBlock(), _createElementBlock("option", {
              key: i,
              value: color.hex
            }, _toDisplayString(color.label), 9, _hoisted_4))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.addColColor]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "color",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addColColor) = $event)),
          title: "Custom color"
        }, null, 512), [
          [_vModelText, _ctx.addColColor]
        ])
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("button", { class: "add-btn" }, "Add", -1))
    ], 32),
    _createVNode(_component_draggable, {
      list: _ctx.columns,
      class: "crm-board-edit-chips"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, i) => {
          return (_openBlock(), _createElementBlock("div", {
            style: _normalizeStyle('background:' + col.color),
            key: i,
            class: _normalizeClass(_ctx.pickingColorFor === col ? 'picking' : ''),
            title: "Click to change the color",
            onClick: ($event: any) => (_ctx.pickingColorFor = _ctx.pickingColorFor === col ? null : col)
          }, [
            _createElementVNode("span", null, _toDisplayString(col.name), 1),
            _createElementVNode("span", {
              class: "crm-board-edit-chip-x",
              title: "Remove",
              onClick: _withModifiers(($event: any) => (_ctx.$emit('remove', i)), ["stop"])
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", { d: "m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" })
              ], -1)
            ]))], 8, _hoisted_6)
          ], 14, _hoisted_5))
        }), 128))
      ]),
      _: 1
    }, 8, ["list"]),
    (_ctx.pickingColorFor && _ctx.columns.includes(_ctx.pickingColorFor))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", null, [
            _cache[14] || (_cache[14] = _createTextVNode("Color for ", -1)),
            _createElementVNode("b", null, _toDisplayString(_ctx.pickingColorFor.name), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pickingColorFor.color) = $event)),
              "aria-label": "Column color"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.colorPalette, (color, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: color.hex
                }, _toDisplayString(color.label), 9, _hoisted_9))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.pickingColorFor.color]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "color",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pickingColorFor.color) = $event)),
              title: "Custom color"
            }, null, 512), [
              [_vModelText, _ctx.pickingColorFor.color]
            ])
          ]),
          _createElementVNode("a", {
            class: "crm-board-edit-link",
            style: {"margin-left":"0"},
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.pickingColorFor = null), ["prevent"]))
          }, "Done")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        type: "button",
        class: "btn",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('save')))
      }, "Save"),
      _createElementVNode("button", {
        type: "button",
        class: "btn-light",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('cancel')))
      }, "Cancel"),
      (_ctx.columns.length)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "crm-board-edit-link",
            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.applyDefaultColors()), ["prevent"]))
          }, "Apply Default Colors"))
        : _createCommentVNode("", true)
    ])
  ]))
}